import { GridColDef } from '@mui/x-data-grid-premium';
import { LogsColumns } from 'components/common/enhanced/common-headers/logs';
import { EnhancedDataGrid } from 'components/common/enhanced/data-grid';
import { getModelLabel } from '../config/modelsMap';
import { logService } from 'services/api/LogService';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import VersionDialog from './VersionDialog';

type Props = {
  modelName: string;
  objectId: string;
  onMetaChange?: (meta: { hasDeleteVersion: boolean; title: string; subtitle: string }) => void;
};

export const ObjectVersionsPanel = (props: Props) => {
  const { modelName, objectId, onMetaChange } = props;
  const { t } = useTranslation();
  const datagridRefresh = useRef(null);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedVersion, setSelectedVersion] = useState<number>(null);
  const [hasDeleteVersion, setHasDeleteVersion] = useState<boolean>(false);

  const handleOpenDialog = (id: number) => {
    setSelectedVersion(id);
    setDialogOpen(true);
  };

  const columns: GridColDef[] = LogsColumns(handleOpenDialog);

  const titleKey = hasDeleteVersion
    ? 'pages.versions.deleted.view.title'
    : 'pages.versions.object.view.title';

  const title = t(titleKey);
  const subtitle = `${getModelLabel(modelName)} id: ${objectId}`;

  useEffect(() => {
    if (!onMetaChange) return;
    onMetaChange({ hasDeleteVersion, title, subtitle });
  }, [hasDeleteVersion, title, subtitle, onMetaChange]);

  return (
    <>
      <EnhancedDataGrid
        columns={columns}
        service={logService}
        refresh={datagridRefresh}
        disableFilter
        outerParams={{ object_id: objectId, model_name: modelName }}
        onDataLoaded={(items) => {
          const hasDelete = items.some((row) =>
            String(row?.action ?? '')
              .toLowerCase()
              .includes('delete')
          );
          setHasDeleteVersion(hasDelete);
        }}
      />
      {selectedVersion && (
        <VersionDialog
          open={dialogOpen}
          onClose={() => {
            setSelectedVersion(null);
            setDialogOpen(false);
          }}
          versionId={selectedVersion}
        />
      )}
    </>
  );
};

export default ObjectVersionsPanel;
